const descriptions = [
    [`Angriff eingeleitet durch $0`,
        `$0 erkämpft sich den Ball`,
        `$0 nimmt $1 die Kugel vom Fuss`,
        `$1 verliert den Ball an $0`],
    [`Er passt vorbei an $1 zu $0`, `$1 vernascht. Flanke auf $0`, `Weiter auf $0`, `$0 an $1 vorbei`
        , `Weitergeleitet auf $0`, `Halb linke Position für $0`,
        `Halb rechte Position für $0`, `Durch die Mitte zu $0`],
    [`$0 lässt $1 stehen und schießt`, `$0 schießt aus zweiter Reihe`, `$1 kann $0 nicht stoppen`],
    [`Tor durch $0. Keine Chance für $1`, `$0 zieht in die linke Ecke. Keine Chance für $1`,
        `Der Ball kommt hoch in den Strafraum. $0 steht goldrichtig und verwandelt eiskalt`,
        `Kopfball von $0. $1 noch mit den Fingerspitzen dran aber der Ball zappelt im Netz`,
        `Kopfball von $0. $1 schaut nur noch hinterher`,
        `$0 köpft mit voller Wucht: Tor`,
        `$1 kann den Ball nicht festhalten. Der abgeprallte Ball kommt auf $0, der nur noch einzulochen braucht`,
        `$0 nimmt den Ball mit der Brust an und schießt aus der Drehung. Traumtor`,
        `Die Pille kullert irgendwie zu $0, der ohne Mühe den Sack zumacht`,
        `$1 rennt $0 entgegen, doch der lässt sich nicht mehr vom Ball trennen und zieht am Torwart vorbei ins Netz`,
        `$0 rennt allein aufs leere Tor zu und schiebt die Pille lässig ins Netz`,
        `$1 faustet am Ball vorbei. Das nutzt $0 und köpft ein. Was für ein Knipser`,
        `$0 steht goldrichtig und verwandet direkt. Keine Chance für $1`],
    [`Abgeblockt von $0`],
    [`Abgewehrt von $0`],
    [`Gehalten von $0`],
    [`Anpfiff`],
    [`Abpfiff`],
    [`Halbzeit`],
    [`Eigentor durch $1`],
    [`$0 humpelt nur noch`,
        `$0 scheint angeschlagen. Er muss sicher gleich raus`,
        `$0 sieht nicht gut aus`,
        `$0 ist verletzt`,
        `$0 angeschlagen`,
        `$0 hat anscheinend Probleme`,
        `Verletzung: $0`],
    [`$0 kommt für $1`],
    [`Verlängerung`],
    [`Seitenwechsel`],
    [`Elfmeterschießen`],
    [`Wiederanpfiff`],
    [`Eiskalt verwandelt von $0`,
        `Unhaltbar für $1`,
        `Unhaltbar von $0 links oben`,
        `Unhaltbar von $0 rechts oben`,
        `Unhaltbar von $0 links unten`,
        `Unhaltbar von $0 rechts unten`,
        `$0 verwandet sicher`,
        `$0 cool in die linke Ecke`,
        `$0 cool in die rechte Ecke`,
        `Mit voller Wucht unter die Latte. Keine Chance für $1`,
        `An den Innenpfosten aber dann noch rein. Glück für $0`,
        `$1 ahnt die Ecke doch kommt nicht mehr dran`,
        `$1 noch dran doch der Schuss von $0 ist zu hart`,
        `$0 verlädt $1 sicher`,
        `$0 hält einfach drauf. $1 verladen`],
    [`$1 schießt meilenweit vorbei`,
        `$1 zieht knapp vorbei`,
        `Vorbei von $1`],
    [`Pfosten`],
    [`Latte`],
    [`Elfmeter für $2`,
        `Elfmeter für $2. $0 tritt an`],
    [`$2 spielt jetzt deutlich motivierter`],
    [`$2 bringt jetzt etwas mehr Härte ins Spiel`],
    [`$2 nimmt jetzt etwas Härte aus dem Spiel`],
    [`$1 reißt $0 von den Beinen`,
        `$0 wird von $1 unfair gestoppt`,
        `Zu harter Einsatz von $1 gegen $0`,
        `Foul von $1 gegen $0`],
    [`$1 reißt $0 brutal von hinten von den Beinen`,
        `$0 wird von $1 durch eine Notbremse gestoppt`,
        `Böser Einsatz von $1 gegen $0`,
        `Brutales Foul von $1 gegen $0`],
    [`Gelbe Karte für $1`,
        `Verwarnung für $1`,
        `Der Schiedrichter zögert nicht lange: Gelber Karton für $1`],
    [`Rote Karte für $1`,
        `Der Schiedsrichter schickt $1 vorzeitig zum Duschen`,
        `Platzverweis für $1`],
    [`Das war einmal zu viel. $1 muss vom Platz`,
        `Gelb-Rot für $1`,
        `Jetzt greift der Schiri durch. $1 sieht gelb-rot`],
    [`Spielabbruch`],
    [`Ecke von links durch $0`,
        `Ecke von rechts durch $0`,
        `$0 bringt eine Ecke direkt vors Tor`,
        `$0 zwirbelt eine Ecke in den Strafraum`,
        `Freistoß von halb-rechts durch $0`,
        `Freistoß von halb-links durch $0`,
        `Indirekter Freistoß für $2. $0 tritt an`,
        `$0 bringt einen Freistoß in den 16er`],
    [`Freistoß von halb-rechts durch $0`,
        `Freistoß von halb-links durch $0`,
        `Freistoß für $2 knapp an der 16er Grenze. $0 tritt an`],
    [`$0 verlängert mit dem Kopf`,
        `Abgefälscht durch $0. Keine Chance für $1`,
        `$0 steht goldrchtig und staubt ab. Tor`,
        `Mit der Hacke verlängert von $0. Vorbei an $1. Traumtor`,
        `$0 nimmt mit der Brust an und verwandelt aus der Drehung`,
        `$0 bekommt den Ball und verlädt $1`],
    [`Der Ball knallt mit voller Wucht unter die Latte. Keine Chance für $1`,
        `An der Mauer vorbei in die linke Ecke`,
        `über die Mauer. Unhaltbar für $1`,
        `Er nutzt das Loch in der Mauer und verlädt $1`,
        `Unhaltbarer Granatenschuss.`,
        `Er zwirbelt die Kugel geschickt um die Mauer unter das Lattenkreuz. Unhaltbar für $1`],
    [`$0 kommt für den verletzten $1`],
    [`Die Spieler von $2 bekommen von ihrem Trainer eine Moralpredigt gehalten`,
        `Bei $2 gab es vor Spielbeginn eine Moralpredigt des Trainers`,
        `Mit einer eindringlichen Moralpredigt macht der Trainer die Spieler von $2 auf die Brisanz des bevorstehenden Spiels aufmerksam`,
        `Das hat gesessen! $2 bekommt vom Trainer eine Moralpredigt gehalten`,
        `Die Nerven liegen bei $2 blank. Eine Moralpredigt des Trainers soll Besserung bringen`,
        `Kurz vor Spielbeginn hält der Trainer von $2 noch eine Moralpredigt. Das bringt zusätzliche Motivation`],
    [`Die Spieler von $2 kommen nach einer ordentlichen Moralpredigt Ihres Trainers aus den Katakomben`,
        `Bei $2 gab es zur Pause eine Moralpredigt des Trainers`,
        `Nach einer Moralpredigt in der Kabine von $2 werden die Spieler wohl nun motivierter ans Werk gehen`,
        `Die Spieler von $2 mussten in der Pause eine Moralpredigt über sich ergehen lassen`]
]

function description(matchReport, matchEvent) {
    let res
    let potentialMessages = descriptions[matchEvent.type]
    if (potentialMessages.length === 0)
        res = potentialMessages[0]
    else
        res = potentialMessages[(matchEvent.minute + matchEvent.number) % potentialMessages.length]
    if(matchEvent.posPlayer)
        res = res.replace('$0', matchEvent.posPlayer.surName)
    if(matchEvent.negPlayer)
        res = res.replace('$1', matchEvent.negPlayer.surName)
    if(res.includes('$2')){
        let team = matchEvent.positiveForHome ? matchReport.team1 : matchReport.team2
        res = res.replace('$2', team.name)
    }
    return res
}

export default description;